<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="single-post single-sponsor"
    id="sponsor-page"
  >
    <PageHeader />
    <wpImage
      v-if="currentPage.featured_image_src"
      :data="currentPage.featured_image_src"
      size="extra_large"
      class="page-featuredimage animate-delay-03"
      lazy
      background
      placeholder
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
    />
    <main class="post-content content-two-row">
      <div class="content">
        <DynamicHtml
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          class="padding_large"
          role="content"
          >{{ currentPage.content.rendered }}</DynamicHtml
        >
      </div>
      <aside class="sidebar padding_large">
        <div
          v-if="
            currentPage.featured_image_src &&
              currentPage.featured_image_src.caption
          "
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          class="img-description"
        >
          {{ currentPage.featured_image_src.caption }}
        </div>

        <Author
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          :id="Number(currentPage.author)"
        />
        <Categories
          v-if="currentPage.acf && currentPage.acf._categories"
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
          taxonomy="sponsors_cat"
          :categories="currentPage.acf._categories"
        />
        <Share
          v-observe-visibility="visibilityChanged"
          :class="[baseAnimation]"
        />
      </aside>
    </main>
    <RelatedPosts :data="relatedPostsData" />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import Author from "@/components/blocks/AuthorBlock";
import Share from "@/components/blocks/ShareBlock";
import Categories from "@/components/blocks/CategoriesBlock";
import RelatedPosts from "@/components/modules/News";

export default {
  name: "single-post",
  components: {
    WpImage,
    Author,
    Share,
    Categories,
    RelatedPosts
  },
  data() {
    return {};
  },
  computed: {
    relatedPostsData() {
      return {
        news_category: this.currentPage.acf._categories,
        theme: "white",
        title: "Relaterte artikler"
      };
    }
  }
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";
</style>
